import { t } from 'state/intl/translations';

import { Coachmark } from './coachmark';

type CloserRestaurantCoachmarkProps = {
  onDismiss: () => void;
};

/**
 * Checkout's closer-restaurant coachmark: the shared `Coachmark` bubble plus this
 * feature's copy and testIDs. Presentation and positioning live in the shared
 * component; eligibility lives in `use-closer-restaurant-coachmark`.
 */
export const CloserRestaurantCoachmark = ({ onDismiss }: CloserRestaurantCoachmarkProps) => (
  <Coachmark
    title={t('closerRestaurantCoachmarkTitle')}
    body={t('closerRestaurantCoachmarkBody')}
    onDismiss={onDismiss}
    testID="closer-restaurant-coachmark"
  />
);
